export enum PropertyCardTypeEnum {
  /**
   * Property card in more properties section
   */
  moreProperty = 'more_property',
}
